import axios from "axios";

// Basic global axios configuration and response error handling.
// This prevents uncaught runtime errors for non-2xx responses (like 404)
// by resolving calls with a normalized object instead of letting them throw.

axios.defaults.timeout = 10000;

axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error && error.response) {
            // Log a concise warning for visibility
            console.warn(
                `[axios] HTTP ${error.response.status} on ${
                    error.config?.url || "unknown"
                }`,
            );

            // Return a resolved object so callers that forgot try/catch
            // receive a stable value and the app doesn't show uncaught errors.
            return Promise.resolve({
                data: null,
                status: error.response.status,
                error: error.response.data,
                _axiosHandled: true,
            });
        }

        // Network / CORS / timeout errors - still reject so they can be handled explicitly
        return Promise.reject(error);
    },
);

export default axios;
